import React from "react";
import CcButton from "../../CoilConfigurator/components/CcButton";
import OpStatusPill from "../components/OpStatusPill";
import type { BuildSpecification } from "../models/types";

interface BuildSpecificationViewProps {
  spec: BuildSpecification;
  onBack: () => void;
  backLabel?: string;
}

const BuildSpecificationView = ({
  spec,
  onBack,
  backLabel = "← Back to results",
}: BuildSpecificationViewProps) => {
  const exportJson = () => {
    const blob = new Blob([JSON.stringify(spec, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${spec.equipmentConfigurationId}-build-spec.json`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const downloadPdf = () => {
    window.print();
  };

  return (
    <article className="op-build">
      <CcButton variant="link" onClick={onBack}>
        {backLabel}
      </CcButton>
      <header className="op-build__head">
        <div>
          <p className="op-kicker">Build Specification</p>
          <h2 className="op-section-title">{spec.equipmentLabel}</h2>
        </div>
        <OpStatusPill status={spec.status} />
      </header>

      <section className="op-form-card">
        <p>Project: {spec.project.projectNumber}</p>
        <p>Equipment: {spec.equipmentLabel}</p>
        <p>Configuration: {spec.equipmentConfigurationId}</p>
        <p>Revision: {spec.revision}</p>
      </section>

      <section className="op-form-card">
        <h3>Equipment Classification</h3>
        {spec.classification.map((item) => (
          <p key={item.label}>
            {item.label}: {item.value}
          </p>
        ))}
      </section>

      <section className="op-form-card">
        <h3>Required Features</h3>
        <ul>
          {spec.requiredFeatures.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="op-form-card">
        <h3>Selected Options</h3>
        <ul>
          {spec.selectedOptions.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="op-form-card">
        <h3>Engineering Parameters</h3>
        {spec.engineeringParameters.map((item) => (
          <p key={item.label}>
            {item.label}: {item.value}
          </p>
        ))}
      </section>

      <section className="op-form-card">
        <h3>CAD Requirements</h3>
        <p>{spec.cadRequirements}</p>
        <h3>Engineering Status</h3>
        <p>{spec.engineeringStatus}</p>
      </section>

      <div className="op-wizard-actions">
        <CcButton variant="secondary" onClick={downloadPdf}>
          Download PDF
        </CcButton>
        <CcButton variant="primary" onClick={exportJson}>
          Export JSON
        </CcButton>
      </div>
    </article>
  );
};

export default BuildSpecificationView;
